import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceCardGrid from "./sections/ServiceCardGrid";
import MaterialBreadthTable from "./sections/MaterialBreadthTable";
import HowItWorks from "./sections/HowItWorks";
import WhoTheseServicesAreFor from "./sections/WhoTheseServicesAreFor";
import ComplianceNote from "./sections/ComplianceNote";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceCardGrid />
      <MaterialBreadthTable />
      <HowItWorks />
      <WhoTheseServicesAreFor />
      <ComplianceNote />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}